export const selectModalConfig = (state = { modal: { queue: [] } }) =>
  state?.modal?.queue?.length > 0 ? state?.modal?.queue[0] : undefined;

export const hasViewedHint = (hintName = '', state) =>
  !!state?.modal?.hintsViewed?.[hintName];
